import { buildUserData, isLvEnvironment } from "./dataLayer";
import gtmEcommercePusher from "./gtmEcommercePusher";

export type TAuthMethod = "email" | "google" | "facebook";

export const pushLoginEvent = (method: TAuthMethod, email?: string | null, phone?: string | null): void => {
  if (!isLvEnvironment()) {
    return;
  }
  gtmEcommercePusher({
    event: "login",
    method,
    ...buildUserData(email, phone),
  });
};

export const pushSignUpEvent = (method: TAuthMethod, email?: string | null, phone?: string | null): void => {
  if (!isLvEnvironment()) {
    return;
  }
  gtmEcommercePusher({
    event: "sign_up",
    method,
    ...buildUserData(email, phone),
  });
};

